export const publishableKey = 'pk_test_51JbccWIGtSdfOPibm3zrptReDXbJVLVo0FpmeskvMEQK6rC3aSvhkFsw8zsh3nN9u9C2XYLRQRKWSnx9oj2xVEai006plL42H3';